import { render } from "./MMEditMainMem.vue?vue&type=template&id=5f804f68"
import script from "./MMEditMainMem.vue?vue&type=script&lang=js"
export * from "./MMEditMainMem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__